import * as React from "react";
const SvgToilet = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor">
      <path d="M8.75 5.75c.966 0 1.75.336 1.75.75s-.784.75-1.75.75S7 6.914 7 6.5s.784-.75 1.75-.75ZM12.5 12.94a.75.75 0 0 0-1.5 0v.453a.75.75 0 0 0 1.5 0v-.453ZM12.5 16.107a.75.75 0 0 0-1.5 0v.453a.75.75 0 0 0 1.5 0v-.453Z" />
      <path d="M15.5 6.5v2h4.75c.966 0 1.75.784 1.75 1.75v9A1.75 1.75 0 0 1 20.25 21H8.75c-1.74 0-3.35-.322-4.555-.874C3.055 19.604 2 18.731 2 17.5V6.453l.003-.07c.064-1.17 1.09-2.004 2.192-2.51C5.399 3.323 7.01 3 8.75 3c1.74 0 3.35.322 4.555.874C14.444 4.396 15.5 5.269 15.5 6.5Zm-12 0c0 .288.287.79 1.32 1.263.967.443 2.356.737 3.93.737H14v-2c0-.288-.287-.79-1.32-1.263-.967-.443-2.356-.737-3.93-.737-1.574 0-2.963.294-3.93.737-1.033.474-1.32.975-1.32 1.263Zm9 3.5v.226a.75.75 0 0 1-1.5 0V10H8.75c-1.74 0-3.35-.322-4.555-.874a5.973 5.973 0 0 1-.695-.373V17.5c0 .287.287.79 1.32 1.262.967.444 2.356.738 3.93.738H11v-.226a.75.75 0 0 1 1.5 0v.226h7.75a.25.25 0 0 0 .25-.25v-9a.25.25 0 0 0-.25-.25H12.5Z" />
    </g>
  </svg>
);
export default SvgToilet;
